<div class="register-wrap">
  <div class="register-card">

    <div class="app-icon">🛒</div>
    <h1 class="register-title">Aanmelding</h1>
    <p class="register-sub">Maak een nieuw account aan</p>

    @if (familyCode) {

      <div class="success-wrap">
        <div class="success-icon">✓</div>
        <p class="success-msg">Account aangemaakt! Bewaar je familiecode:</p>
        <div class="code-box">
          <span class="code-value" id="family-code">{{ familyCode }}</span>
          <button type="button" class="code-copy"
                  (click)="copyCode()">{{ codeCopied ? 'Gekopieerd!' : 'Kopieer' }}</button>
        </div>
        <p class="code-hint">Deel deze code met gezinsleden zodat zij kunnen inloggen.</p>
        <button type="button" class="submit-btn" (click)="goToLogin()">Verder naar inloggen</button>
      </div>

    } @else {

      @if (statusText) {
        <div class="{{ statusClass }}">{{ statusText }}</div>
      }

      <form [formGroup]="form" (ngSubmit)="submit()" class="register-form">

        <div class="field-block">
          <label class="field-label">Naam abonnement</label>
          <input class="field-input" formControlName="subscription"
                 placeholder="Bijv. Familie van Vugt" autocomplete="off">
        </div>

        <div class="field-block">
          <label class="field-label">Omschrijving</label>
          <input class="field-input" formControlName="description"
                 placeholder="Bijv. Huize van Vugt" autocomplete="off">
        </div>

        <div class="field-block">
          <label class="field-label">Gebruikersnaam</label>
          <input class="field-input" formControlName="username" autocomplete="username">
        </div>

        <div class="field-block">
          <label class="field-label">E-mailadres</label>
          <input class="field-input" formControlName="email"
                 type="email" autocomplete="email">
        </div>

        <div class="field-block">
          <label class="field-label">Pincode</label>
          <div class="pin-wrap">
            <input class="field-input pin-input" formControlName="password"
                   [type]="showPassword ? 'text' : 'password'"
                   inputmode="numeric" autocomplete="new-password">
            <button type="button" class="pin-toggle" (click)="showPassword = !showPassword"
                    [attr.aria-label]="showPassword ? 'Verberg pincode' : 'Toon pincode'">
              {{ showPassword ? 'Verberg' : 'Toon' }}
            </button>
          </div>
        </div>

        <button type="submit" class="submit-btn" [disabled]="clicked || !form.valid">
          Aanmelden
        </button>

      </form>

    }

  </div>
</div>
